import { render } from "./MailForm.vue?vue&type=template&id=91732db6&ts=true"
import script from "./MailForm.vue?vue&type=script&lang=ts"
export * from "./MailForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__